export default __webpack_public_path__ + "media/src/features/home-page-redesign/assets/view-b942d5206a7ddccdda47b02233273259.png";